import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { LiveopsRewardType } from '@/modules/liveops/item/types';
import { liveopsPointService } from '@/services/liveops';

export function useLiveopsList(rewardType?: LiveopsRewardType) {
    const { confirmAndEnable, confirmAndDisable, confirmAndRemove } = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            rewardType: { type: 'number', default: rewardType ?? LiveopsRewardType.Milestone },
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: liveopsPointService.item.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute
        }
    });

    const actions = {
        enable: confirmAndEnable({
            request: liveopsPointService.item.enable,
            onSuccess: () => fetchList()
        }),
        disable: confirmAndDisable({
            request: liveopsPointService.item.disable,
            onSuccess: () => fetchList()
        }),
        remove: confirmAndRemove({
            request: liveopsPointService.item.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, query, fetchList, actions };
}
